import { SafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

const CropPopup = lazy(() => import(/* webpackChunkName: 'crop_popup' */'./crop_popup'))

export default (props) => (
  <SafeSuspense fallback={null}>
    <CropPopup {...props} />
  </SafeSuspense>
)
